import React from 'react';

interface KPICard {
  title: string;
  Icon: React.ElementType;
  children: React.ReactNode;
}

export const KPIStatCard: React.FC<KPICard> = ({ title, Icon, children }) => {
  return (
    <div className="border rounded-lg pt-6 flex flex-col overflow-auto shadow-sm ">
      <dt className="flex items-center gap-4 px-6 bg-white ">
        <div className="rounded-md bg-primary p-3">
          <Icon aria-hidden="true" className="h-6 w-6 text-white" />
        </div>
        <p className=" truncate text-lg font-semibold text-black">{title}</p>
      </dt>

      <div className="flex bg-gray-50 w-full py-3 px-6 h-full mt-5">{children}</div>
    </div>
  );
};
